import * as apiHelper from './../helpers/apiHelper';
import * as loadingActions from './loadingActions';

export var restoreRental = (id) => {
	return {
		type: "RESTORE_RENTAL",
		id
	}
}

export var startRestoreRental = (id) => {
	return (dispatch, getState) => {
		dispatch(loadingActions.setSaving());
		const url = "rentals/" + id + "/restore";

		return apiHelper.apiRequest(url, 'put', null, dispatch, getState).then((res) => {
			if (res.ok) {
				dispatch(restoreRental(id));
			} 
			dispatch(loadingActions.removeLoading());
			return res.ok ? null : res.errors;
		});	
	};
};


// WEBPACK FOOTER //
// ./src/actions/rentalActions.js